import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

const OWNER_EMAIL = 'arihantdeva@gmail.com'

export function isOwner(email: string | null | undefined): boolean {
  return email?.toLowerCase() === OWNER_EMAIL
}

export default function OwnerRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()

  if (!isOwner(user?.email)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
